'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value", "pixelValue"],
  _excluded2 = ["className", "tooltip", "label", "disabled", "onChange", "onStep", "allowUnitDimensions", "pixelValue"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BATTLESHIP, KOALA } from 'HubStyleTokens/colors';
import UIInputGroup from 'UIComponents/form/UIInputGroup';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
import Small from 'UIComponents/elements/Small';
import { isPercentage, percentageStringToNumber, pixelStringToNumber } from '../../utils/table';
import PercentageStepperInput from '../table/controls/TablePopoverPercentageStepperInput';
import PixelStepperInput from '../table/controls/TablePopoverPixelStepperInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const asStyledStepperInput = StepperInput => styled(StepperInput).withConfig({
  displayName: "SplitLabelStepperInput__asStyledStepperInput",
  componentId: "sc-2hkvyg-0"
})(["font-size:12px !important;input{font-size:14px !important;height:32px !important;padding-bottom:4px !important;padding-top:4px !important;}"]);
const SplitStepperInput = asStyledStepperInput(UIStepperInput);
const SplitPercentageStepperInput = asStyledStepperInput(PercentageStepperInput);
const SplitPixelStepperInput = asStyledStepperInput(PixelStepperInput);
const UnitSplitStepperInput = props => {
  const {
      value,
      pixelValue
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (isPercentage(value)) {
    return /*#__PURE__*/_jsx(SplitPercentageStepperInput, Object.assign({}, rest, {
      size: 7,
      value: percentageStringToNumber(value)
    }));
  } else {
    return /*#__PURE__*/_jsx(SplitPixelStepperInput, Object.assign({}, rest, {
      size: 7,
      value: pixelStringToNumber(pixelValue)
    }));
  }
};
const disabledLabelStyles = `
  background-color: ${KOALA};
  border-color: ${KOALA};
  box-shadow: none !important;
  color: ${BATTLESHIP};
  cursor: not-allowed;
`;
const SplitLabelControl = styled(UIFormControl).withConfig({
  displayName: "SplitLabelStepperInput__SplitLabelControl",
  componentId: "sc-2hkvyg-1"
})(["font-weight:600;line-height:30px;border:1px solid ", ";border-top-left-radius:3px;border-bottom-left-radius:3px;", ""], BATTLESHIP, ({
  disabled
}) => disabled ? disabledLabelStyles : '');
const propTypes = {
  className: PropTypes.string,
  tooltip: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onStep: PropTypes.func.isRequired,
  allowUnitDimensions: PropTypes.bool,
  pixelValue: PropTypes.number
};
const defaultProps = {
  size: 5,
  stepSize: 1,
  min: 0
};
function SplitLabelStepperInput(props) {
  const {
      className,
      tooltip,
      label,
      disabled,
      onChange,
      onStep,
      allowUnitDimensions,
      pixelValue
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded2);
  const handleChange = evt => {
    const {
      value: updatedValue
    } = evt.target;
    onChange(updatedValue);
  };
  const handleStep = evt => {
    const {
      value: updatedValue
    } = evt.target;
    onStep(updatedValue);
  };
  const StepperInput = allowUnitDimensions ? UnitSplitStepperInput : SplitStepperInput;
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltip,
    placement: "bottom",
    disabled: disabled,
    children: /*#__PURE__*/_jsxs(UIInputGroup, {
      className: className,
      use: "none",
      children: [/*#__PURE__*/_jsx(SplitLabelControl, {
        "aria-label": "split-stepper-label",
        disabled: disabled,
        children: /*#__PURE__*/_jsx(Small, {
          className: "p-x-1",
          children: label
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        "aria-label": "split-stepper-input",
        children: /*#__PURE__*/_jsx(StepperInput, Object.assign({}, rest, {
          pixelValue: allowUnitDimensions ? pixelValue : undefined,
          disabled: disabled,
          onChange: handleChange,
          onStep: handleStep
        }))
      })]
    })
  });
}
SplitLabelStepperInput.propTypes = propTypes;
SplitLabelStepperInput.defaultProps = defaultProps;
SplitLabelStepperInput.displayName = 'SplitLabelStepperInput';
export default SplitLabelStepperInput;